
import Vue from "vue";
import TransProgramOverviewContent from "@/components/transPrograms/TransProgramOverviewContent.vue";
import ImageContentCard from "@/components/common/ImageContentCard.vue";
import CloseButton from "@/components/common/CloseButton.vue";
import store from "@/store";
import { VueConstructor } from "vue/types/umd";
import UIFeatureMixinVue from "@/mixins/UIFeatureMixin.vue";
import { UI_ENDPOINT } from "@/constants/EndPoints";

export default (
  Vue as VueConstructor<Vue & InstanceType<typeof UIFeatureMixinVue>>
).extend({
  name: "home-content",
  components: { TransProgramOverviewContent, ImageContentCard, CloseButton },
  mixins: [UIFeatureMixinVue],
  data() {
    return {
      availableCountiesDialog: false as boolean,
    };
  },
  created() {
    if (this.scheduleCounties.length === 0) {
      let url = UI_ENDPOINT.GET_SCHEDULE_COUNTIES;
      store.dispatch.dataModule.getScheduleCounties(url);
    }
  },
  computed: {
    scheduleCounties() {
      return store.getters.dataModule.getScheduleCountiesInStore;
    },
  },
});
